export default __webpack_public_path__ + "static/media/dog.0c122234.svg";